export function transformTnsUrl(url: string, name: string): string {
  let transformedUrl = url.trim();
  
  // Определяем тип поля
  const isPixel = ['click_audit_pixel', 'pixel', 'pixel_additional', 'pixel_additional2'].includes(name);
  const isLink = name === 'link';
  
  // Проверяем, является ли это ссылкой TNS
  const isTnsCounter = url.includes('tns-counter.ru');
  
  // Для link поля - возвращаем ссылку без изменений
  if (isLink) {
    return transformedUrl;
  }
  
  // Для pixel поля - обрабатываем только tns-counter.ru ссылки
  if (isPixel) {
    if (!isTnsCounter) {
      return transformedUrl; // Не TNS ссылка для pixel поля
    }
    
    // Для pixel: добавляем {RND} в конец ссылки
    // Проверяем, не добавлен ли уже {RND}
    if (!transformedUrl.includes('{RND}')) {
      // Добавляем {RND} в конец
      transformedUrl += '{RND}';
    }
  }
  
  // Для других полей (не link и не pixel) - возвращаем как есть
  if (!isLink && !isPixel) {
    return transformedUrl;
  }
  
  return transformedUrl;
}